import { Component, EventEmitter, Output } from '@angular/core';

@Component({
  selector: 'app-input-filter',
  templateUrl: './input-filter.component.html',
  styleUrls: ['./input-filter.component.scss']
})
export class InputFilterComponent {
  @Output() public searchChanged = new EventEmitter<string>();
  public search!: string;

  public constructor() {
    this.search = '';
  }

  public setSearchValue(value: string): void {
    this.search = value;
    this.applyFilter();
  }

  public applyFilter(): void {
    this.searchChanged.emit(this.search);
  }

  public hasFilterSelected(): boolean {
    return this.search !== null && this.search !== '';
  }

  public clearFilters(): void {
    this.search = '';
    this.applyFilter();
  }
}
